import { Box, Button, Container, TextField, Typography } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { styled } from '@mui/material/styles';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import Loading from './Loading';
import '../components/Style.css';
import {
  useSavePaymentMethodMutation,
  useUpdatePaymentMethodMutation,
  useUploadPaymentMethodImageMutation,
} from '../store/api/paymentApi';

type Props = {};

const PaymentSchema = Yup.object().shape({
  description: Yup.string().required('Please enter description').trim(),
  title: Yup.string().required('Please enter payment title').trim(),
});

const ResponsiveBox = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

const FormikBox = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    marginLeft: '0px',
  },
  [theme.breakpoints.up('md')]: {
    marginLeft: '20px',
  },
}));

const AddPaymentGetaway = (props: Props) => {
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    description: '',
    title: '',
    isEnable: true,
  });
  const [isImgUrl, setIsImgUrl] = useState(false);
  const { state }: any = useLocation();
  const token = JSON.parse(localStorage.getItem('login') || '{}').token;
  const [savePaymentDetail, addPaymentDataResponse] = useSavePaymentMethodMutation();
  const [updatePaymentDetail, updatePaymentDataResponse] = useUpdatePaymentMethodMutation();
  const [uploadPaymentImage, uploadPaymentImageResponse] = useUploadPaymentMethodImageMutation();
  const [submitData, setSubmitData] = useState<any | null>();
  const paymentImageInput: any = useRef();
  const [paymentImage, setPaymentImage] = useState<null | any>();

  const validate = (values: any) => {
    const errors: any = {};
    if (!values.description || values.description == '<p><br></p>') errors['description'] = 'This field is required';
    return errors;
  };

  const handleAddOrUpdatePayment = (values: any, action: any) => {
    if (!state.editMode) {
      setSubmitData({
        description: values.description,
        name: values?.title,
        fileUrl: paymentImage,
        isEnable: values.isEnable,
      });
      const formData = new FormData();
      formData.append('file', paymentImage);
      uploadPaymentImage({
        token: token,
        payload: formData,
        id: 1,
      });
    } else {
      setSubmitData({
        id: state.editData.id,
        description: values.description,
        name: values?.title,
        fileUrl: paymentImage,
        isEnable: values.isEnable,
      });
      if (!isImgUrl) {
        const formData = new FormData();
        formData.append('file', paymentImage);
        uploadPaymentImage({
          token: token,
          payload: formData,
        });
      } else {
        updatePaymentDetail({
          token: token,
          payload: {
            id: state.editData.id,
            description: values.description,
            name: values?.title,
            isEnable: values.isenable,
            fileUrl: paymentImage.split('?')[0].split('com/')[1],
          },
        });
      }
    }
  };

  useEffect(() => {
    if (state.editData) {
      setInitialValues({
        title: state.editData.name,
        description: state.editData.description,
        isEnable: state.editData.isEnable,
      });
      setPaymentImage(state.editData.fileUrl);
      setIsImgUrl(true);
    }
  }, []);

  useEffect(() => {
    if (uploadPaymentImageResponse.isSuccess && !state.editMode) {
      savePaymentDetail({
        token: token,
        payload: { ...submitData, fileUrl: uploadPaymentImageResponse.data.imagePath },
      });
    } else if (uploadPaymentImageResponse.isSuccess && !isImgUrl) {
      updatePaymentDetail({
        token: token,
        payload: { ...submitData, fileUrl: uploadPaymentImageResponse.data.imagePath },
      });
    } else if (uploadPaymentImageResponse.isError) {
      toast.error('Image size is too large');
    }
  }, [uploadPaymentImageResponse.isSuccess, uploadPaymentImageResponse.isError]);

  useEffect(() => {
    if (addPaymentDataResponse.isSuccess) {
      toast.success('Payment added successfully');
      navigate('/dashboard/payments-method', { replace: true });
    } else if (addPaymentDataResponse.isError) {
      let errorData: any = addPaymentDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }

    if (updatePaymentDataResponse.isSuccess) {
      toast.success('Payment updated successfully');
      navigate('/dashboard/payments-method', { replace: true });
    } else if (updatePaymentDataResponse.isError) {
      let errorData: any = updatePaymentDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [
    addPaymentDataResponse.isSuccess,
    addPaymentDataResponse.isError,
    updatePaymentDataResponse.isSuccess,
    updatePaymentDataResponse.isError,
  ]);

  return (
    <Box>
      <Container>
        <h1>{state.editMode ? 'Edit Payment Method' : 'Add Payment Method'}</h1>
        <ResponsiveBox style={{ display: 'flex', paddingTop: '40px' }}>
          <Box>
            <input
              type="file"
              name="payment-image"
              id="payment-image"
              ref={paymentImageInput}
              accept="image/gif, image/jpeg, image/png"
              onChange={(event: any) => {
                if (state.editMode && isImgUrl) {
                  setIsImgUrl(false);
                }
                setPaymentImage(event.target.files[0]);
              }}
              hidden
            />
            <Box
              onClick={() => {
                paymentImageInput.current.click();
              }}
            >
              {paymentImage && (
                <Box style={{ position: 'relative' }}>
                  <img
                    src={state.editMode && isImgUrl ? paymentImage : URL.createObjectURL(paymentImage)}
                    alt=""
                    height={200}
                    width={200}
                    style={{ borderRadius: '100px' }}
                  />
                  <Box
                    style={{
                      background: 'white ',
                      padding: '3px',
                      borderRadius: '100px',
                      position: 'absolute',
                      bottom: '5px',
                      right: '30px',
                      fontSize: '34px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '40px',
                      width: '40px',
                    }}
                  >
                    <AddPhotoAlternateIcon />
                  </Box>
                </Box>
              )}

              <div
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '10px',
                  fontSize: '27px',
                  backgroundColor: 'white',
                  width: '26px',
                  height: '32px',
                  borderRadius: '50%',
                }}
              ></div>
              {!paymentImage && (
                <Box
                  style={{
                    background: 'lightgray',
                    height: 200,
                    width: 200,
                    borderRadius: '100px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <h5>Upload photo</h5>
                </Box>
              )}
            </Box>
            <Box style={{ textAlign: 'center', marginTop: '10px' }}>
              <p>Allowed *.jpeg, *.jpg, *.png, *.gif</p>
              <p> Max size of 3.1 MB</p>
            </Box>
          </Box>
          <FormikBox style={{ flex: 1, padding: 0 }}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              onSubmit={handleAddOrUpdatePayment}
              validationSchema={PaymentSchema}
              validate={validate}
            >
              {({ handleBlur, handleChange, handleSubmit, values, touched, errors, setFieldValue }) => (
                <Box>
                  <Box style={{ width: '100%' }}>
                    <Typography variant="h5" marginTop={2} gutterBottom component="div">
                      Title
                    </Typography>
                    <TextField
                      fullWidth
                      type="text"
                      name="title"
                      label="Enter payment title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.title && errors.title)}
                      helperText={touched.title && errors.title}
                    />
                  </Box>

                  <Box style={{ width: '100%' }}>
                    <Typography variant="h5" marginTop={2} gutterBottom component="div">
                      Description
                    </Typography>
                    <TextField
                      fullWidth
                      type="text"
                      name="description"
                      label="Enter payment description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.description && errors.description)}
                      helperText={touched.description && errors.description}
                    />
                  </Box>
                  <Box style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <Button
                      variant="contained"
                      style={{ color: 'white', backgroundColor: '#E23744' }}
                      onClick={() => {
                        navigate('/dashboard/payments-method');
                      }}
                      sx={{ marginRight: '10px' }}
                      size="large"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      style={{ color: 'white', backgroundColor: '#E23744' }}
                      size="large"
                      component="span"
                      onClick={() => {
                        if (!paymentImage) {
                          toast.error('Please upload an image');
                        } else {
                          handleSubmit();
                        }
                      }}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              )}
            </Formik>
          </FormikBox>
        </ResponsiveBox>
      </Container>
      {addPaymentDataResponse.isLoading ||
      updatePaymentDataResponse.isLoading ||
      uploadPaymentImageResponse.isLoading ? (
        <Loading />
      ) : null}
    </Box>
  );
};

export default AddPaymentGetaway;
